import React, { useEffect, useState } from "react";
import Navbar from "../widgets/Navbar";
import Sidebar from "../widgets/Sidebar";
import { useTranslation } from "react-i18next";
import { useLeverageByUserQuery } from "../../redux/forexApi";
import {
  useGetPakageListQuery,
  useOpenNewAccountMutation,
} from "../../redux/accountApi";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Footer from "../widgets/Footer";

const NewAccount = () => {
  const navigate = useNavigate();
  const { data: leverageData } = useLeverageByUserQuery();
  const { data: pakageData } = useGetPakageListQuery();
  const { t } = useTranslation();
  const [accountType, setAccountType] = useState("real");
  const [nickname, setNickname] = useState("");
  const [nickNameErro, setNickNameErro] = useState("");
  const [demoAmount, setDemoAmount] = useState("500");
  const [leverageList, setLeverageList] = useState([]);
  const [selectedLeverage, setSelectedLeverage] = useState("");
  const [leverageErr, setleverageErr] = useState("");
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [isPakageSelected, setIsPakageSelected] = useState(false);
  const [selectedPakage, setSelectedPakage] = useState("");
  const [accountOptions, setAccountOptions] = useState([]);
  const [depositErr, setDepositErr] = useState("");
    const [passwordShow, setPasswordShow] = useState({
      eye: "bi-eye-slash",
      type: "password",
    });

  const [openNewAccount] = useOpenNewAccountMutation();

  useEffect(() => {
    if (leverageData) {
      setLeverageList(leverageData);
    }

    if (pakageData) {
      setAccountOptions(pakageData);
    }
  }, [leverageData, pakageData]);

  const showcurrentPassword = () => {
    if (passwordShow.type === "password") {
      setPasswordShow({ eye: "bi-eye", type: "text" });
    } else {
      setPasswordShow({ eye: "bi-eye-slash", type: "password" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "leverage-list") {
      setSelectedLeverage(value);
      if (!value) {
        setleverageErr("Please select leverage");
      } else {
        setleverageErr("");
      }
    }

    if (name === "nickname") {
      setNickname(value);
      if (!value) {
        setNickNameErro("Nickname is require");
      } else {
        setNickNameErro("");
      }
    }

    if (name === "password") {
      setPassword(value);
      if (!value) {
        setPasswordErr("Password is require");
      }
    }

    if (name === "deposit-amount") {
      // Allow only numbers & limit to 8 digits
      const sanitizedValue = value.replace(/[^0-9.]/g, ""); // allow digits + dot
      if (sanitizedValue.length > 8) return; // Block more than 8 digits

      setDemoAmount(sanitizedValue);

      // Numeric validation
      const numericValue = parseFloat(sanitizedValue);
      if (!sanitizedValue) {
        setDepositErr("Deposit amount is required");
      } else if (isNaN(numericValue)) {
        setDepositErr("Please enter a valid number");
      } else if (numericValue < 100) {
        setDepositErr("Minimum deposit amount is 100");
      } else if (numericValue > 99999999) {
        setDepositErr("Deposit amount should not exceed 8 digits");
      } else {
        setDepositErr("");
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedLeverage) {
      setleverageErr("Please select leverage");
      return false;
    }

    if (!nickname) {
      setNickNameErro("Nickname is require");
      return false;
    }

    if (!password) {
      setPasswordErr("Password is require");
    }

    const accountData = {
      accountType: accountType,
      nickname: nickname,
      selectedLeverage: selectedLeverage,
      password: password,
      demoAmount: demoAmount,
      pakageId: selectedPakage,
    };
    const res = await openNewAccount(accountData);
    if (res.data) {
      toast.success("Account created successfully");
      setNickname("");
      setSelectedLeverage("");
      setPassword("");
      setleverageErr("");
      setNickNameErro("");
      setPasswordErr("");
      setTimeout(() => {
        navigate("/multi-account");
      }, 500);
    }
  };

  const handleAccountSelect = (type) => {
    setIsPakageSelected(true);
    setSelectedPakage(type.id);
  };

  return (
    <div>
      <Navbar />
      <section className="  border_all br_0 bl_0  min_h70vh mb-4">
        <div className="container ">
          <div className="pt-3 pt-md-4 pt-3  pb-2 d-md-flex">
            <h4 className="mb-0  mr-auto">
              <span
                className="mr-2 cursor-pointer"
                onClick={() => navigate("/multi-account")}
              >
                <i class="bi bi-arrow-left"></i>
              </span>
              {t("Open New Account")}
            </h4>
            {isPakageSelected && (
              <ul className="exchange_tab2  mb-auto br10  d-flex   position-relative mt-3 mt-md-0 new_account_tab">
                <li
                  className={accountType === "real" ? "my_color_buy" : ""}
                  onClick={() => setAccountType("real")}
                >
                  Real
                </li>
                <li
                  className={accountType === "demo" ? "my_color_buy" : ""}
                  onClick={() => setAccountType("demo")}
                >
                  Demo
                </li>
              </ul>
            )}
          </div>
          <p>Trade with real money and withdraw any profit you may make</p>
          {!isPakageSelected ? (
            <div className="new_account_box">
              <div className="row">
                {accountOptions.map((acc, index) => (
                  <div className="col-md-3 mb-4" key={index}>
                    <div className="card bg3 border br10 p-4 mb-4 text-white h-100">
                      {acc.recommended === 1 && (
                        <span className="badge color1 mb-2">Recommended</span>
                      )}

                      <h5 className="text-white mb-1">{acc.name}</h5>
                      <p className="small text-muted mb-3">{acc.description}</p>

                      <hr />

                      <p className="mb-1">
                        <strong>Minimum Deposit:</strong> {acc.minDeposit}
                      </p>
                      <p className="mb-1">
                        <strong>Spread:</strong> {acc.spread}
                      </p>
                      <p className="mb-3">
                        <strong>Commission:</strong> {acc.commission}
                      </p>

                      <button
                        className="btn btn-success btn-sm w-100"
                        onClick={() => handleAccountSelect(acc)}
                      >
                        Select {acc.name}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <form>
              <div className="bg3 br10 p-3 p-md-4 ">
                <div className=" ">
                  <div className="form-group">
                    <label className="fw-500">Max leverage *</label>
                    <select
                      className="form-control"
                      aria-label="Default select example"
                      value={selectedLeverage}
                      onChange={handleChange}
                      name="leverage-list"
                    >
                      <option value="">Choose leverage</option>
                      {leverageList.map((item) => (
                        <option value={item.id} key={item.id}>
                          1:{item.amount}
                        </option>
                      ))}
                    </select>
                    {leverageErr && (
                      <span className="text-danger">{leverageErr}</span>
                    )}
                  </div>
                  {accountType === "demo" && (
                    <div className="form-group">
                      <label className="fw-500">Starting balance *</label>
                      <input
                        className="form-control"
                        value={demoAmount}
                        onChange={handleChange}
                        name="deposit-amount"
                      />
                      {depositErr && (
                        <span className="text-danger">{depositErr}</span>
                      )}
                    </div>
                  )}
                  <div className="form-group">
                    <label className="fw-500">Account nickname *</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter account nickname"
                      value={nickname}
                      onChange={handleChange}
                      name="nickname"
                      autocomplete="off"
                    />
                    {nickNameErro && (
                      <span className="text-danger">{nickNameErro}</span>
                    )}
                  </div>
                  {/* <div className="form-group">
                    <label className="fw-500">
                      Create a password for the account *
                    </label>
                    <div className="position-relative">
                      <input
                        type={passwordShow?.type}
                        className="form-control"
                        placeholder="Enter account password"
                        value={password}
                        onChange={handleChange}
                        name="password"
                        autocomplete="new-password"
                      />
                      <span
                        className="password__show eye1   position-absolute"
                        onClick={showcurrentPassword}
                      >
                        <i className={`bi ${passwordShow.eye}`}></i>
                      </span>
                      {passwordErr && (
                        <span className="text-danger">{passwordErr}</span>
                      )}
                    </div>
                  </div> */}
                  <div className="form-group">
                  
                  </div>
                  <div className="form-group">
                    <button
                      className="btn w100px btn_man "
                      onClick={handleSubmit}
                    >
                      Create an Account
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default NewAccount;
